import DocumentPageContainer from "@/features/documents/containers/document-page-container";
import { createFileRoute } from "@tanstack/react-router";

// Inferred path (child of $clientId): /app/clients/$clientId/document/$documentId
export const Route = createFileRoute(
  "/app/clients/$clientId/document/$documentId"
)({
  validateSearch: (search: Record<string, unknown>) => ({
    edit: search.edit === true || search.edit === "true" || search.edit === "1",
  }),
  component: DocumentPageContainer,
});
